export default __webpack_public_path__ + "static/media/fastlane_detail7.77ce632a.jpg";